import buchoImg from './katuo.jpg'; // 画像を src/assets に置く

export default function Join() {
  return (
    <div className="fade-in join-container">
      <h2>名誉部長カッツオ</h2>
      <img src={buchoImg} alt="部長の写真" className="bucho-img" />
      <p>キハダマグロのカッツオダッツオ！！！</p>
      <p>好きな食べ物はイナダ嫌いな食べ物はブリダッツオ</p>
      <p>入部を心よりお待ちしております。</p>
    </div>
  );
}
